import commonReducer from "./modalCommonReducer";

const reducers = { common: commonReducer };

export default reducers;
